import {
    FETCH_EVENTS_CONTENT_SUCCESS,
    FETCH_EVENTS_CONTENT_FAILED,
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    news: []
};

export default function (state = initialState, { type, payload }) {
    switch (type) {
        case FETCH_EVENTS_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload
            };
        case FETCH_EVENTS_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload
            };

        default:
            return state;
    }
}
